<template>
  <div class="csv-page-wrap">
    <div class="form-wrap">
      <h1>Upload a CSV document</h1>
      <label>Select type:</label>
      <select name="csv-opts" v-model="type">
        <option :value="'regular'">Regular</option>
        <option :value="'pass'">Pass</option>
        <option :value="'free-link'">Free Link</option>
      </select>
      <div class="input-wrap">
        <label for="file">Browse</label>
        <input type="file" id="file" @change="getFile">
        <span>{{file.name}}</span>
        <div class="expected-format">
          <span>Expected format:</span>
          <p>
            Name,Lastname,E-mail,Gender,City,Country,Company,Company position
          </p>
        </div>
        <button v-if="isFileValid && type" @click="setCsv">Upload document</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AdminMixin from '../admin-pages/adminMixin'
export default {
  mixins: [
    AdminMixin
  ],
  data () {
    return {
      file: '',
      fileString: '',
      isFileValid: false,
      type: 'regular',
    }
  },
  methods: {
    getFile (e) {
      this.file = e.target.files[0];
      if (this.file) {
        var reader = new FileReader();
        let fileContents;
        
        reader.addEventListener('load', (e) => {
          fileContents = e.target.result;
          this.validateFile(fileContents);
          this.fileString = fileContents;
        });
        reader.readAsText(this.file);
      }
    },
    validateFile (fileContents) {
      let fileRows = fileContents.split('\n');
      if (fileRows[fileRows.length-1] === '') fileRows.pop();
      for (let i = 0; i < fileRows.length; i++) {
        let rowWords = fileRows[i].split(',');
        if (rowWords.length !== 8) {
          this.isFileValid = false;
          this.handleError(new Error(`Error on line ${i+1}. Please verify the document format.`))
          return;
        }
      }

      this.isFileValid = true;
      this.showSuccessMessage('File format correct.');
    },
    async setCsv () {
      let res;

      let upload = async (chunk) => {
        let res;
        const apiObj = {
          csv: chunk,
          type: this.type,
        };
        res = await api.setCsv(apiObj);
        return res;
      } 
      try {
        this.startLoading();
        let fileRows = this.fileString.split('\n');
        if (fileRows[fileRows.length-1] === '') fileRows.pop();
        let chunk = '';
        for (let i = 0; i < fileRows.length; i++) {
          const row = fileRows[i];
          chunk += row + "\n";
          if (i !== 0 && (i+1) % 15 === 0) {
            await upload(chunk);
            chunk = '';
          }
        }
        if (chunk.length !== 0) res = await upload(chunk);

        if (res && res.data.err) {
          this.handleError(new Error(res.data.err));
        } else {
          this.showSuccessMessage('File Uploaded.');
        }
      } catch (error) {
        this.handleError(error)
      } 
      this.stopLoading();
    }
  }
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.csv-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1% 10% 1% 3%;
}
.form-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  box-shadow: 0px 0px 36px -11px rgba(0, 0, 0, 0.75);
  border-radius: 20px;
  padding: 0 20px 20px 20px;
  select {
    margin-bottom: 2em;
  }
}
.input-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input-wrap label {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 20px;
  font-weight: 600;
  background: #f68d22;
  color: white;
  text-align: center;
}
input[type="file"] {
  display: none;
}
button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 20px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
  margin-top: 50px;
}
.expected-format {
  opacity: 0.4;
  margin: 20px 0;
}
p {
  margin: 0;
}
</style>